/// <amd-module name="Pipeline/Analytics/PipelineStepsDurationCard/DurationUtils" />
import * as ChartDataConverter from "Analytics/Shared/Common/Utils/ChartDataConverter";
import { DurationNormalizer } from "Analytics/Shared/TrendChart/Common/DurationNormalizer";
import { INormalizedDuration } from "Analytics/Shared/TrendChart/Common/Types";
import { IPipelineStepDurationTrend } from "Pipeline/Analytics/PipelineStepsDurationCard/Types";

export function normalizeDurationData(chartData: IPipelineStepDurationTrend[]) {
    const durationNormalization = new DurationNormalizer();
    let normalizedDuration: INormalizedDuration;

    let durationUnit = "";

    chartData.forEach(trendData => {
        Object.keys(trendData.stepsDurationData).forEach(stageData => {
            const durationList: number[][] = [];
            durationList.push(trendData.stepsDurationData[stageData].map(d => d.stepDuration));
            normalizedDuration = durationNormalization.normalizeDurations(durationList, true);
            const updatedValues: number[] = ChartDataConverter.formatData(normalizedDuration.durationValues[0]);
            const length = trendData.stepsDurationData[stageData].length;
            for (let i = 0; i < length; i++) {
                trendData.stepsDurationData[stageData][i].stepDuration = updatedValues[i];
            }
            durationUnit = normalizedDuration ? normalizedDuration.durationUnitString : "";
        });
    });

    return { chartData: chartData, durationUnit: durationUnit };
}
